<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Role Management</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <!-- <add-staff-grade @created="handleCreated"/> -->
          <add-role @created="handleCreated"></add-role>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <role-table :data="data" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddRole from '@/components/role/Forms/Add/index'
import RoleTable from '@/components/role/table'

export default {
  components: {
    AddRole,
    RoleTable,
  },
  mounted: function() {
    // this.getFakeRole()
    this.getRole()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
    }
  },
  // watch: {
  //   data: {
  //     function (newdata, olddata) {
  //       console.log(`olddata \n${olddata}`)
  //       console.log(`\nnewdata \n${newdata}`)
  //       (function(){
  //         this.data = []
  //       })()
  //     },
  //     deep: true
  //   }
  // },
  methods: {
    getRole: function () {
      this.loading = true
      this.$http.get('/api/school-role', {
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        // this.meta = data.meta // Meta not found in api
      })
    },
    handleCreated: function() {
      // this.getFakeRole()
      this.getRole()
    },
    handleUpdateTable: function() {
      // this.getFakeRole()
      this.getRole()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      // this.getFakeRole()
      this.getRole()
    },
    onChange(current) {
      this.current = current
      // this.getFakeRole()
      this.getRole()
    },
  },
}
</script>
